import './App.css';
import { ClientApp } from './screens/client';
import { AdminApp } from './screens/admin';
import React, { useEffect } from 'react';
import { Constants } from './constants/general.constant';
import { LoadScriptNext } from '@react-google-maps/api';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase/firebaseApp';
import { ensureUserProfile, getAuthenticatedUserProfile } from './firebase/userProfile';
export const UserContext = React.createContext({});

const GOOGLE_MAPS_LIBRARIES = ['places'];

function App() {
  var SelectedApp;
  const [user, setUser] = React.useState({});
  const updateReadCount = async () => {};

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setUser({});
        return;
      }
      try {
        const profile = await getAuthenticatedUserProfile(firebaseUser.uid);
        if (profile) {
          setUser(profile);
          return;
        }
        await ensureUserProfile(firebaseUser.uid, {
          email: firebaseUser.email,
          name: firebaseUser.displayName || firebaseUser.email,
          role: process.env.REACT_APP_MODE,
        });
      } catch (e) {
        console.error("[AUTH] Failed to load profile", e);
      }
      setUser({
        id: firebaseUser.uid,
        uid: firebaseUser.uid,
        email: firebaseUser.email,
        name: firebaseUser.displayName || firebaseUser.email,
      });
    });
    return () => unsubscribe();
  }, []);
  switch (process.env.REACT_APP_MODE) {
    case Constants.CLIENT:
      SelectedApp = ClientApp;
      break;
    default:
      SelectedApp = AdminApp;
  }
  return <LoadScriptNext
    googleMapsApiKey={Constants.GOOGLE_API_KEY}
    libraries={GOOGLE_MAPS_LIBRARIES}
  ><UserContext.Provider value={{ user, setUser, updateReadCount }}>
      <SelectedApp />
      <ToastContainer 
      position="top-center"
      theme="colored"
      
      />
    </UserContext.Provider>
  </LoadScriptNext>
}

export default App;
